import { Settings01 } from "@untitled-ui/icons-react/build/esm";
import { Box, Button, SvgIcon } from "@mui/material";
import Stack from "@mui/material/Stack";
import type { FC } from "react";
import { useDataDisplay } from "~/hooks/use-data-display";
import { useMeCache } from "~/queries/useMe";
import { ROLE } from "~/types/__generated/gql/graphql";
import { FileDisplaySettingsDialog } from "./file-display-settings-dialog";
export const FileDisplaySettingsButton: FC = () => {
  const {
    data: me
  } = useMeCache();
  const {
    file,
    handleFileFormModelOpen,
    handleFileFormModelClose,
    handleChangeFileFormSettings
  } = useDataDisplay();
  if (me?.role !== ROLE.SUPER_ADMIN) return null;
  return <>
			<Box sx={{
      backgroundColor: theme => theme.palette.mode === "dark" ? "neutral.800" : "neutral.100",
      borderRadius: 2.5,
      mx: 1
    }} data-sentry-element="Box" data-sentry-source-file="file-display-settings-button.tsx">
				<Stack alignItems="center" direction="row" onClick={handleFileFormModelOpen} spacing={1} data-sentry-element="Stack" data-sentry-source-file="file-display-settings-button.tsx">
					<Button startIcon={<SvgIcon>
								<Settings01 />
							</SvgIcon>} variant="contained" data-sentry-element="Button" data-sentry-source-file="file-display-settings-button.tsx">
						Form Settings
					</Button>
				</Stack>
			</Box>

			{file.isFormModelOpen && <FileDisplaySettingsDialog file={file} changeFileDisplayFormSettings={handleChangeFileFormSettings} onClose={handleFileFormModelClose} />}
		</>;
};